import { TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// 라벨 스타일
export const StyledLabel = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#111827',
  marginBottom: '8px',
  display: 'block',
});

// TextField 공통 스타일
export const StyledTextField = styled(TextField)(({ hasValue }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#F9FAFB',
    borderRadius: '12px',
    '& fieldset': {
      borderColor: '#E5E7EB',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#2EBD36',
    },
    '&.Mui-disabled': {
      backgroundColor: '#E5E7EB',
    },
  },
  '& .MuiInputBase-input': {
    fontSize: '1rem',
    color: '#111827',
    '&::placeholder': {
      color: '#9CA3AF',
      opacity: 1,
    },
    '&::-webkit-datetime-edit-year-field': {
      color: hasValue ? '#111827' : '#9CA3AF',
    },
    '&::-webkit-datetime-edit-month-field': {
      color: hasValue ? '#111827' : '#9CA3AF',
    },
    '&::-webkit-datetime-edit-day-field': {
      color: hasValue ? '#111827' : '#9CA3AF',
    },
  },
}));

// Combo wrap 스타일 (wrapSx prop으로 전달)
export const comboWrapStyles = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#F9FAFB !important',
    borderRadius: '12px',
    '& fieldset': {
      borderColor: '#E5E7EB',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#2EBD36',
    },
    '&.Mui-disabled': {
      backgroundColor: '#E5E7EB !important',
    },
  },
  '& .MuiSelect-select': {
    backgroundColor: 'transparent !important',
    fontSize: '1rem', // 16px (최소)
    color: '#111827',
  },
  '& .MuiInputBase-input': {
    fontSize: '1rem', // 16px (최소)
    color: '#111827',
  },
};
